var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import produce from 'immer';
var initialCardAssignErr = {
    code: '',
    decline_code: '',
    doc_url: '',
    message: '',
    request_id: '',
    status: 0,
    type: '',
};
var cardAssignErrIfErrorNotAvailable = {
    code: 'cardAssignErrWithoutStripe',
    decline_code: '',
    doc_url: '',
    message: '',
    request_id: '',
    status: 0,
    type: '',
};
export var initialState = {
    confirmPaymentError: '',
    confirmPaymentLoading: false,
    confirmPaymentStatus: false,
    getSecretLoading: false,
    getSecretError: false,
    cardAssignLoading: false,
    cardAssigned: false,
    cardAssignError: __assign({}, initialCardAssignErr),
    purchaseBundleLoading: false,
    purchaseBundleError: false,
    purchaseBundle: false,
    clientSecret: '',
    modalMode: '',
    cardState: '',
    inputMode: '',
    bundle: {},
};
function paymentModalReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'PaymentModal/CARD_ASSIGN_REQUEST':
                state.cardAssignLoading = true;
                state.cardAssigned = false;
                state.cardAssignError = __assign({}, initialCardAssignErr);
                break;
            case 'PaymentModal/CARD_ASSIGN_SUCCESS':
                state.cardAssignLoading = false;
                state.cardAssigned = true;
                state.cardAssignError = __assign({}, initialCardAssignErr);
                if (action.action) {
                    state.clientSecret = action.action.client_secret;
                    state.cardState = action.action.cardState;
                }
                break;
            case 'PaymentModal/CARD_ASSIGN_FAILURE':
                state.cardAssignLoading = false;
                state.cardAssigned = false;
                state.cardAssignError =
                    action.action ||
                        cardAssignErrIfErrorNotAvailable;
                break;
            case 'PaymentModal/GET_SECRET_REQUEST':
                state.clientSecret = '';
                state.getSecretLoading = true;
                state.confirmPaymentError = '';
                break;
            case 'PaymentModal/GET_SECRET_FAILURE':
                state.getSecretLoading = false;
                state.confirmPaymentError = '';
                break;
            case 'PaymentModal/GET_SECRET_SUCCESS':
                state.clientSecret = action.action.client_secret;
                state.getSecretLoading = false;
                break;
            case 'PaymentModal/CONFIRM_PAYMENT_REQUEST':
                state.confirmPaymentLoading = true;
                state.confirmPaymentError = '';
                state.confirmPaymentStatus = false;
                break;
            case 'PaymentModal/CONFIRM_PAYMENT_SUCCESS':
                state.confirmPaymentLoading = false;
                state.confirmPaymentError = '';
                state.confirmPaymentStatus = true;
                break;
            case 'PaymentModal/CONFIRM_PAYMENT_FAILURE':
                state.confirmPaymentLoading = false;
                state.confirmPaymentError = action.action;
                break;
            case 'PaymentModal/RESET_MODAL':
                state.confirmPaymentError = '';
                state.clientSecret = '';
                state.inputMode = '';
                state.confirmPaymentStatus = false;
                break;
            case 'PaymentModal/RESET_PAYMENT':
                state.confirmPaymentError = '';
                state.clientSecret = '';
                state.confirmPaymentStatus = false;
                break;
            case 'PaymentModal/CHANGE_MODAL_MODE':
                state.modalMode = action.action;
                break;
            case 'PaymentModal/CHANGE_INPUT_MODE':
                state.inputMode = action.action;
                break;
            case 'PaymentModal/CREATE_INVOICE_REQUEST':
                state.confirmPaymentLoading = true;
                state.confirmPaymentError = '';
                state.confirmPaymentStatus = false;
                break;
            case 'PaymentModal/CREATE_INVOICE_FAILURE':
                state.confirmPaymentLoading = false;
                state.confirmPaymentError = 'Unable to create invoice';
                state.confirmPaymentStatus = true;
                break;
            case 'PaymentModal/CREATE_INVOICE_SUCCESS':
                state.confirmPaymentLoading = false;
                state.confirmPaymentError = '';
                state.confirmPaymentStatus = true;
                break;
            case 'PaymentModal/PURCHASE_BUNDLES_REQUEST':
                state.purchaseBundleLoading = true;
                state.purchaseBundleError = false;
                state.purchaseBundle = false;
                break;
            case 'PaymentModal/PURCHASE_BUNDLES_SUCCESS':
                state.purchaseBundleLoading = false;
                state.purchaseBundle = true;
                state.purchaseBundleError = false;
                break;
            case 'PaymentModal/PURCHASE_BUNDLES_FAILURE':
                state.purchaseBundleLoading = false;
                state.purchaseBundleError = true;
                state.purchaseBundle = false;
                break;
            case 'PaymentModal/SET_CLIENT_SECRET':
                state.clientSecret = action.action;
                break;
            case 'PaymentModal/RESET_CLIENT_SECRET':
                state.clientSecret = '';
                state.cardState = '';
                break;
            default:
                break;
        }
    });
}
export default paymentModalReducer;
